import { formatDollarAmount, isNotNullOrUndefined } from '@converge/utils';

import { NotApplicable } from './not-applicable';
import { Typography } from '@mui/material';

export const CurrencyOrNotApplicable = ({
  children,
  tooltipText,
}: {
  children?: number | null | undefined;
  tooltipText?: string;
}) => {
  return isNotNullOrUndefined(children) ? (
    <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
      {formatDollarAmount(children)}
    </Typography>
  ) : (
    <NotApplicable tooltipText={tooltipText} />
  );
};
